<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ condoCorporationName }}</span>
		<app-button
			(click)="create()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			>Create</app-button
		>
	</div>
</ng-template>

<ng-template #condoCorporationTemplate let-item>
	<div
		class="flex flex-col"
		[matTooltip]="item.name | titlecase"
		[matTooltipShowDelay]="600"
	>
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>
<div class="py-2">
	<app-auto-complete
		placeholder="Search Condo Corporation"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: (condoCorporations$ | async),
				template: condoCorporationTemplate,
				title: 'Condo Corporations',
				noResultsMessage: 'No Condo corporations found',
				type: dropdownSelect.SELECT_CONDO_CORPORATION,
			},
		]"
		[(ngModel)]="condoCorporationName"
		name="dual-dropdown-1"
		[minSearchTerm]="2"
		[loading]="loading"
		(debounce)="search($event)"
		width="w-full"
		[label]="label"
		(onSelect)="onSelectCondoCorporation($event)"
	>
	</app-auto-complete>
</div>
